import React from "react"
import styled from "styled-components"
import {
  StandardContainer,
  BodyCopy,
  CallToAction,
  StyledHeading,
} from "../../common"

const StyledCTA = styled.div`
  text-align: center;
  background: ${(props) => props.$bgColor || "#fff"};
`

export const CenteredCTA = ({
  heading,
  text,
  link_type,
  page_link,
  link_target,
  link_text,
  anchor_id,
  block_background,
}) => {
  return (
    <StyledCTA $wrappedStandard id={anchor_id} $bgColor={block_background}>
      <StandardContainer>
        <StyledHeading size="h2">{heading?.text}</StyledHeading>
        <BodyCopy
          dangerouslySetInnerHTML={{ __html: text?.html }}
          $measureLarge
        />
        <CallToAction
          type={link_type}
          text={link_text}
          target={link_target}
          page={page_link}
        />
      </StandardContainer>
    </StyledCTA>
  )
}
